import { useLocation, useNavigate, useParams } from "react-router-dom";
import React from "react";

export const withRouter = (Component) => {
  function ComponentWithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const match = {'params': params, 'path': location.pathname}

    const history = {'push': navigate, 'replace': navigate}

    return (
      <Component
        {...props}
        location={location}
        history={history}
        match={match}
      />
    );
  }

  return ComponentWithRouterProps;
};
